export class CashRegisterOpenShiftLocalRequest {
    cashRegisterId?: number;
    accessToken?: string;
} 